import React from "react"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../../redux/items/types"
import { connect } from "react-redux"
import { browserHistory } from "react-router"
import { glAccountsDataWithId, sortGLAccounts, validateTextState, VALIDATION_TYPE } from "../../../lib/utils"
import { blockingFetchService } from "../../../lib/blockingFetch"
import CloseableProcessesStatus from "../../fragments/CloseableProcessesStatus"
import { Form } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import FormControlInlineSelect from "../../fragments/FormControl.Inline.Select"
import FormControlInlineCheckbox from "../../fragments/FormControl.Inline.Checkbox"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import FormButtons from "../../fragments/FormButtons"
import ButtonUpdate from "./../ButtonUpdate"
import apiServerApi from "../../../redux/sagas/apiServerApi"

class ExtraAccountingForm extends React.Component {

  constructor(props) {

    super(props)
    this.state = {
      accountToDebit: '',
      accountToCredit: '',
      accountToDebitVAT: '',
      disabled: false,

      accountToDebitValidationState: VALIDATION_TYPE.NULL,
      accountToCreditValidationState: VALIDATION_TYPE.NULL,
      accountToDebitVATValidationState: VALIDATION_TYPE.NULL,

      running: false,
      success: false,
      error: null,
      closeStatuses: false,
    }
  }

  isUpdate = this.props.isUpdate
  uri='/extraaccounting'
  text='Extra configuration'
  info='Automatic Journal Entries of loans using purchase costs of bundles'

  componentDidMount() {
    this.props.loadGLAccounts()
    this.loadConfiguration()
  }

  componentWillUnmount() {
    clearTimeout(this.timeOutId)
  }

  loadConfiguration = () => {

    this.setState({
      running: true,
      error: null,
      closeStatuses: false,
    })

    blockingFetchService(
      accessToken => apiServerApi.getExtraLoanAccountingRule(accessToken),
      data => this.dataLoaded(data),
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  dataLoaded = data => {

    if (!data) return

    const { accountToDebit: { id: accountToDebit }, accountToCredit: { id: accountToCredit },
      accountToDebitVAT, disabled } = data,

    // NB: accountToDebitVAT can be null
    accountToDebitVATId = accountToDebitVAT ? accountToDebitVAT.id : ''

    this.setState({
      accountToDebit,
      accountToCredit,
      accountToDebitVAT: accountToDebitVATId,
      disabled
    })
  }

  accountToDebitChanged = accountToDebit => this.setState({
    accountToDebit,
    accountToDebitValidationState: validateTextState(accountToDebit, false),
    error: null,
  })

  accountToCreditChanged = accountToCredit => this.setState({
    accountToCredit,
    accountToCreditValidationState: validateTextState(accountToCredit, false),
    error: null,
  })

  accountToDebitVATChanged = accountToDebitVAT => this.setState({
    accountToDebitVAT,
    accountToDebitVATValidationState: validateTextState(accountToDebitVAT, false),
    error: null,
  })

  disabledChanged = () => this.setState({
    disabled: !this.state.disabled
  })

  valid = () => {

    const { accountToCredit, accountToDebit, accountToDebitVAT } = this.state,
    accountToCreditState = validateTextState(accountToCredit),
    accountToDebitState = validateTextState(accountToDebit),
    accountToDebitVATState = validateTextState(accountToDebitVAT)

    this.setState({
      accountToDebitValidationState: accountToDebitState,
      accountToCreditValidationState: accountToCreditState,
      accountToDebitVATValidationState: accountToDebitVATState,
    })

    return (
      accountToCreditState === VALIDATION_TYPE.SUCCESS &&
      accountToDebitState === VALIDATION_TYPE.SUCCESS &&
      accountToDebitVATState === VALIDATION_TYPE.SUCCESS
    )
  }

  saveData = () => {

    this.setState({ closeStatuses: false })

    if(!this.valid()) {
      this.setState({ error: 'Some fields are incorrect.' })
      return
    }

    const { accountToCredit, accountToDebit, accountToDebitVAT, disabled } = this.state,
    data = { 
      accountToCredit: { id: accountToCredit },
      accountToDebit: { id: accountToDebit },
      accountToDebitVAT: { id: accountToDebitVAT },
      usePurchaseCost: true,
      disabled,
    }

    this.setState({
      running: true,
      error: null,
      success: false,
    })

    blockingFetchService(
      accessToken => apiServerApi.saveExtraLoanAccountingRule(accessToken, data),
      _ => {
        this.setState({ success: true })
        this.timeOutId = setTimeout(() => {
          this.setState({ success: false })
          browserHistory.push(this.uri)
        }, 2000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  renderForm = () => {

    const { accountToCredit, accountToDebit, accountToDebitVAT, disabled,
      accountToCreditValidationState, accountToDebitValidationState,
      accountToDebitVATValidationState } = this.state,

    { glAccounts } = this.props,

    glAccountsData = glAccountsDataWithId(glAccounts)

    return <Form horizontal onSubmit={e => { e.preventDefault(); this.saveData() }}>

      <FormControlInlineSelect
        controlId='accountToDebit' validationState={ accountToDebitValidationState }
        label='Account to debit (Net price)' value={ accountToDebit }
        onChange={ this.accountToDebitChanged }
        options={ glAccountsData }
        withEmptyOption={ true }
        helpText={ accountToDebitValidationState === VALIDATION_TYPE.ERROR ? 'Choose an account' : '' }
        disabled={ !this.isUpdate }
      />

      <FormControlInlineSelect
        controlId='accountToDebitVAT' validationState={ accountToDebitVATValidationState }
        label='Account to debit (VAT)' value={ accountToDebitVAT }
        onChange={ this.accountToDebitVATChanged }
        options={ glAccountsData }
        withEmptyOption={ true }
        helpText={ accountToDebitVATValidationState === VALIDATION_TYPE.ERROR ? 'Choose an account' : '' }
        disabled={ !this.isUpdate }
      />

      <FormControlInlineSelect
        controlId='accountToCredit' validationState={ accountToCreditValidationState }
        label='Account to credit (VAT Incl.)' value={ accountToCredit }
        onChange={ this.accountToCreditChanged }
        options={ glAccountsData }
        withEmptyOption={ true }
        helpText={ accountToCreditValidationState === VALIDATION_TYPE.ERROR ? 'Choose an account' : '' }
        disabled={ !this.isUpdate }
      />

      <FormControlInlineCheckbox
        controlId='disabled' label='Disabled'
        validationState={ VALIDATION_TYPE.NULL } value={ disabled }
        onChange={ this.disabledChanged }
        disabled={ !this.isUpdate }
      />

      <FormControlInlineCheckbox
        controlId='purchaseCost' label='Use Purchase Cost'
        validationState={ VALIDATION_TYPE.NULL } value={ true }
        disabled={ true }
      />
    </Form>
  }

  renderContent = () => {

    const { running, error, success, closeStatuses } = this.state

    return (
    <div className="simple-form max-width-700 mx-auto mb-20">

      <div className="flex-row flex-wrap">

        <p className="hot-color">
          <FontAwesome name='info-circle' /> &nbsp; { this.info }
        </p>

        { !this.isUpdate && (
        <ButtonUpdate
          onClick={() => browserHistory.push(this.uri + '/edit')}
          running={ running }
        />)}
      </div>
      <hr/>

      { this.renderForm() }

      <CloseableProcessesStatus
        error={ error }
        success={ success }
        close={ closeStatuses }
        handleClose={() => this.setState({ closeStatuses: true })}
      />

      { this.isUpdate && (
      <FormButtons onSave={ this.saveData }
        onCancel={() => browserHistory.push(this.uri)}
        running={ running }
      />)}
    </div>
  )}

  render() {
    const dataBreadCrumbs = [{ url: '/accounting', title: 'Accounting' }]

    return (
      <div>
        <CustomBreadCrumb activeText={ this.text } data={ dataBreadCrumbs } />
        { this.renderContent() }
      </div>
    )
  }
}

const mapStateToProps = state => {

  const glAccounts = DckSelectors.selectAllItems(state, ItemTypes.GLAccount)
  sortGLAccounts(glAccounts)
  return { glAccounts }
},

mapDispatchToProps = dispatch => ({
  loadGLAccounts: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.GLAccount)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ExtraAccountingForm)



// WEBPACK FOOTER //
// ./src/components/Accounting/ExtraAccounting/Form.js